import React, { useState } from 'react';

import { Building2, Network, Shield, Clock, Server } from 'lucide-react';
import ProdukMetroE from '../../components/navbar/internet/metro-e/produk';
import Footer from '../../components/footer/index';
import { useDarkMode } from '../../components/darkmode/DarkModeContext';

const MetroEPage = () => {
  const { isDarkMode } = useDarkMode(); // gunakan konteks dark mode (seperti Services)

  const [selectedPackage, setSelectedPackage] = useState(null);
  const [activeTab, setActiveTab] = useState('semua');

  const packages = [
    {
      id: 'metro-starter',
      category: 'small-business',
      speed: '10 Mbps',
      name: 'Metro-E Starter',
      description: 'Solusi dedicated untuk bisnis kecil dengan kebutuhan stabil',
      price: 'Rp 2.500.000',
      originalPrice: 'Rp 3.200.000',
      discount: '22%',
      badge: 'BISNIS KECIL',
      badgeColor: 'bg-green-600',
      popular: false,
      features: [
        { name: 'Dedicated 10 Mbps', icon: '/image/icon/Dedicated.png' },
        { name: 'SLA 99.5%', icon: '/image/icon/SLA.png' },
        { name: 'Static IP (1)', icon: '/image/icon/IP_STATIC.png' },
        { name: 'Support 24/7', icon: '/image/icon/support.png' },
        { name: 'Monitoring real-time', icon: '/image/icon/priority.png' },
        { name: 'Backup connection', icon: '/image/icon/router.png' }
      ],
      ideal: ['Small office', 'Retail store', 'Clinic', 'Startup'],
      devices: '50+ devices',
      installation: 'Survey lokasi',
      support: 'Business 24/7',
      sla: '99.5%'
    },
    {
      id: 'metro-business',
      category: 'medium-business',
      speed: '50 Mbps',
      name: 'Metro-E Business',
      description: 'Bandwidth dedicated untuk operasional bisnis menengah',
      price: 'Rp 8.500.000',
      originalPrice: 'Rp 11.000.000',
      discount: '23%',
      badge: 'POPULER',
      badgeColor: 'bg-blue-900',
      popular: true,
      features: [
        { name: 'Dedicated 50 Mbps', icon: '/image/icon/Dedicated.png' },
        { name: 'SLA 99.8%', icon: '/image/icon/SLA.png' },
        { name: 'Static IP (5)', icon: '/image/icon/IP_STATIC.png' },
        { name: 'Priority support', icon: '/image/icon/priority.png' },
        { name: 'Network monitoring', icon: '/image/icon/support.png' },
        { name: 'Redundant connection', icon: '/image/icon/router.png' }
      ],
      ideal: ['Medium office', 'E-commerce', 'School', 'Government'],
      devices: '200+ devices',
      installation: 'Professional setup',
      support: 'Priority 24/7',
      sla: '99.8%'
    },
    {
      id: 'metro-enterprise',
      category: 'enterprise',
      speed: '100 Mbps',
      name: 'Metro-E Enterprise',
      description: 'Solusi enterprise dengan bandwidth tinggi dan SLA premium',
      price: 'Rp 15.000.000',
      originalPrice: 'Rp 19.500.000',
      discount: '23%',
      badge: 'ENTERPRISE',
      badgeColor: 'bg-purple-600',
      popular: false,
      features: [
        { name: 'Dedicated 100 Mbps', icon: '/image/icon/Dedicated.png' },
        { name: 'SLA 99.9%', icon: '/image/icon/SLA.png' },
        { name: 'Static IP (10)', icon: '/image/icon/IP_STATIC.png' },
        { name: 'Dedicated support', icon: '/image/icon/priority.png' },
        { name: 'Advanced monitoring', icon: '/image/icon/support.png' },
        { name: 'Multiple redundancy', icon: '/image/icon/router.png' }
      ],
      ideal: ['Large corporation', 'Data center', 'Hospital', 'Bank'],
      devices: '500+ devices',
      installation: 'Enterprise deployment',
      support: 'Dedicated 24/7',
      sla: '99.9%'
    },
    {
      id: 'metro-custom',
      category: 'custom',
      speed: 'Custom',
      name: 'Metro-E Custom',
      description: 'Solusi kustomisasi penuh sesuai kebutuhan khusus bisnis',
      price: 'Custom Pricing',
      originalPrice: null,
      discount: null,
      badge: 'CUSTOM',
      badgeColor: 'bg-orange-600',
      popular: false,
      features: [
        { name: 'Custom bandwidth', icon: '/image/icon/Dedicated.png' },
        { name: 'SLA up to 99.99%', icon: '/image/icon/SLA.png' },
        { name: 'Multiple static IP', icon: '/image/icon/IP_STATIC.png' },
        { name: 'Account manager', icon: '/image/icon/priority.png' },
        { name: 'Custom monitoring', icon: '/image/icon/support.png' },
        { name: 'Disaster recovery', icon: '/image/icon/router.png' }
      ],
      ideal: ['Telco operator', 'ISP', 'Cloud provider', 'Mission critical'],
      devices: 'Unlimited',
      installation: 'Consultation',
      support: 'Account manager',
      sla: 'Up to 99.99%'
    }
  ];

  const tabs = [
    { id: 'semua', label: 'Semua Paket', count: packages.length },
    { id: 'small-business', label: 'Bisnis Kecil', count: packages.filter(p => p.category === 'small-business').length },
    { id: 'medium-business', label: 'Bisnis Menengah', count: packages.filter(p => p.category === 'medium-business').length },
    { id: 'enterprise', label: 'Enterprise', count: packages.filter(p => p.category === 'enterprise').length },
    { id: 'custom', label: 'Custom', count: packages.filter(p => p.category === 'custom').length }
  ];

  const filteredPackages = activeTab === 'semua' 
    ? packages 
    : packages.filter(pkg => pkg.category === activeTab);

  return (
    <div className={`min-h-screen transition-colors duration-500 ${
      isDarkMode ? 'bg-slate-900 text-white' : 'bg-white text-gray-900'
    }`}>
      {/* HERO GREEN GRADIENT */}

      {/* HERO GREEN GRADIENT */}
      <div className="relative overflow-hidden bg-gradient-to-br from-[#1E9B4C] via-green-600 to-green-800 text-white">
        <div className="absolute inset-0 bg-black/20"></div>
        {/* Decorative Elements */}
        <div className="absolute top-20 right-10 w-32 h-32 rounded-full bg-white/10 blur-xl"></div>
        <div className="absolute bottom-20 left-10 w-40 h-40 rounded-full bg-green-300/20 blur-xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full bg-green-400/10 blur-3xl"></div>

        <div className="relative container mx-auto px-6 py-24">
          <div className="text-center">
            <div className="flex justify-center mb-6">
              <div className="bg-white/20 backdrop-blur-sm p-4 rounded-2xl">
                <Building2 className="w-16 h-16 text-white" />
              </div>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-white to-green-200 bg-clip-text text-transparent">
              Metro Ethernet (Metro-E)
            </h1>
            <p className="text-xl md:text-2xl mb-8 opacity-90 max-w-3xl mx-auto">
              Koneksi internet dedicated berkecepatan tinggi dengan SLA terjamin untuk kebutuhan bisnis enterprise
            </p>

            <div className="flex flex-wrap justify-center gap-8 mb-12">
              <div className="flex items-center gap-3">
                <Network className="w-8 h-8 text-green-300" />
                <span className="text-lg font-semibold">Dedicated Bandwidth</span>
              </div>
              <div className="flex items-center gap-3">
                <Shield className="w-8 h-8 text-green-300" />
                <span className="text-lg font-semibold">SLA up to 99.99%</span>
              </div>
              <div className="flex items-center gap-3">
                <Clock className="w-8 h-8 text-green-300" />
                <span className="text-lg font-semibold">24/7 Support</span>
              </div>
            </div>

            <button className="bg-white text-[#1E9B4C] hover:bg-gray-100 px-8 py-4 rounded-xl font-bold text-lg transition-all transform hover:scale-105">
              Konsultasi Gratis
            </button>
          </div>
        </div>
      </div>

      {/* Produk MetroE (sudah menggunakan DarkModeContext di komponennya) */}
      <ProdukMetroE />

      {/* Features Section */}
      <div
        className={`relative py-16 overflow-hidden ${
          isDarkMode ? 'bg-slate-800/80' : 'bg-[#dfe4e0ff]'
        }`}
      >
        {/* Background image */}
        <div className="absolute inset-0">
          <img
            src="https://telnet.net.id/assets/bg.png"
            alt="Background pattern"
            className="w-full h-full object-cover opacity-20"
          />
        </div>

        {/* Overlay dekoratif agar teks tetap terbaca */}
        <div className={`absolute inset-0 ${isDarkMode ? 'bg-black/30' : 'bg-white/30'}`}></div>

        <div className="container mx-auto px-6 relative z-10">
          <h2
            className={`text-4xl font-bold text-center mb-12 ${
              isDarkMode ? 'text-white' : 'text-gray-900'
            }`}
          >
            Keunggulan Metro Ethernet
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Feature 1 */}
            <div className="text-center">
              <div
                className={`w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center ${
                  isDarkMode ? 'bg-[#1E9B4C]/30' : 'bg-[#1E9B4C]/10'
                }`}
              >
                <Network className="w-8 h-8 text-[#1E9B4C]" />
              </div>
              <h3 className={`text-xl font-semibold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                Dedicated Bandwidth
              </h3>
              <p className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
                Bandwidth yang dijamin penuh tanpa berbagi dengan pengguna lain
              </p>
            </div>

            {/* Feature 2 */}
            <div className="text-center">
              <div
                className={`w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center ${
                  isDarkMode ? 'bg-green-900/40' : 'bg-green-100'
                }`}
              >
                <Shield className="w-8 h-8 text-green-600" />
              </div>
              <h3 className={`text-xl font-semibold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                SLA Terjamin
              </h3>
              <p className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
                Service Level Agreement hingga 99.99% dengan kompensasi jika tidak terpenuhi
              </p>
            </div>

            {/* Feature 3 */}
            <div className="text-center">
              <div
                className={`w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center ${
                  isDarkMode ? 'bg-emerald-900/40' : 'bg-emerald-100'
                }`}
              >
                <Server className="w-8 h-8 text-emerald-600" />
              </div>
              <h3 className={`text-xl font-semibold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                Redundant Connection
              </h3>
              <p className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
                Multiple jalur koneksi untuk memastikan uptime maksimal
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-gradient-to-r from-[#1E9B4C] to-green-700 py-24">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
            Siap Upgrade Infrastruktur IT Perusahaan?
          </h2>
          <p className="text-xl mb-8 opacity-90 text-white">
            Konsultasi gratis dengan expert kami untuk menentukan solusi terbaik
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="https://wa.me/6287778882022" target="_blank" rel="noopener noreferrer">
            <button className="bg-white text-[#1E9B4C] hover:bg-gray-100 px-8 py-3 rounded-lg font-semibold transition-colors">
              Konsultasi Gratis
            </button>
            </a>
            {/* <button className="border border-white text-white hover:bg-white/10 px-8 py-3 rounded-lg font-semibold transition-colors">
              Download Brochure
            </button> */}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default MetroEPage;